/**
 * Copyright Mántum All Rights Reserved.
 */
import Internal from '../internal/select';
import ReactSelect from 'react-select';
import { forwardRef } from 'react';

import type {
    DataSource,
    Detail,
    Filter,
    Group,
    Option,
    Options,
    Result,
    Validation
} from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        entity?: string;
        filter?: Filter;
        group?: Group;
        menuShouldScrollIntoView?: boolean;
        options?: Option<string>;
        placement?: 'auto' | 'top' | 'bottom';
        position?: 'fixed' | 'absolute';
        result?: Result;
    };
    dataSource?: Options<unknown> | DataSource;
    disabled?: boolean;
    error?: boolean;
    instanceId?: number | string;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (
        name?: string,
        value?: Option<unknown> | Options<unknown> | unknown
    ) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: Validation;
    value?: Options<unknown>;
};

export default forwardRef<Detail<unknown>, PropTypes>(
    function Multiple(props, ref) {
        return (
            <Internal
                {...props}
                multiple={true}
                ref={ref}
                render={ReactSelect}
                searchable={false}
            />
        );
    }
);
